'use client'
import { useSearchType } from '@/api/hooks'
import HomeGrid from '@/app/(site)/home-grid'
import { AdDecision } from '@/app/util/ads-endpoint'
import { useIsMobile } from '@/app/util/use-media-query'
import { useAdOffsets } from '@/components/grid/use-ad-offsets'
import { SearchTypeContext } from '@/context/search-type'
import useClientRender from '@/util/use-client-render'
import { ComponentProps, useContext } from 'react'
import { useWindowSize } from 'react-use'
import SpotlightGrid from '../spotlight-grid'
import { clickableAdWidth } from '../spotlight-grid/spotlight-util'
import VideoSpotlight from '../video-spotlight-grid'
import ClickableAd from './clickable-ad'
import SpotlightContainer from './container'

type Props = {
    trendingGifs: ComponentProps<typeof HomeGrid>['trendingGifs']
    spotlightData?: AdDecision
    clickableAd?: AdDecision
}

function SpotlightOrVideoGrid({ trendingGifs, spotlightData, clickableAd }: Props) {
    const spotlightGif = spotlightData?.gif
    const clickableAdGif = clickableAd?.gif

    const isVideo = spotlightGif?.video

    const type = useSearchType()
    const { isTransitioning } = useContext(SearchTypeContext)
    const isMobile = useIsMobile()

    const { width: windowWidth } = useWindowSize()

    const clientRender = useClientRender()

    const includeSpotlight =
        !!spotlightGif && type !== 'clips' && !(type === 'stickers' && !isVideo) && !isTransitioning

    const { columnOffsets } = useAdOffsets({
        clickableAdGif: clickableAdGif || null,
        spotlightGif: spotlightGif || null,
        includeSpotlight,
        isMobile,
        windowWidth,
        type,
        clientRender,
    })
    return (
        <>
            {!isTransitioning && (
                <>
                    {includeSpotlight ? (
                        <>
                            {spotlightGif && (
                                <SpotlightContainer>
                                    {isVideo ? (
                                        <VideoSpotlight data={spotlightData} />
                                    ) : (
                                        <SpotlightGrid data={spotlightData} />
                                    )}
                                </SpotlightContainer>
                            )}
                        </>
                    ) : (
                        clickableAdGif &&
                        clientRender &&
                        type === 'gifs' && (
                            <ClickableAd
                                ad={clickableAd}
                                gif={clickableAdGif}
                                width={isMobile ? windowWidth / 2 - 3 : clickableAdWidth}
                                isMobile={isMobile}
                            />
                        )
                    )}
                </>
            )}

            <HomeGrid trendingGifs={trendingGifs} columnOffsets={columnOffsets} hasClickableAd={!!clickableAd} />
        </>
    )
}

export default SpotlightOrVideoGrid
